<template>
    <div>
        <div class="row">
            <div class="col-12 text-center my-lg-5">
                <h2>{{ translations.Cart }}</h2>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-xl-7 cart-products">
                <div class="row mb-3">
                    <div class="col">
                        <h3>{{ translations['Products'] }}</h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div id="products-box">
                            <div class="row" v-for="product in products" :key="product.id">
                                <product-line :product="product" />
                            </div>
                            <div class="row">
                                <div class="col summary-box">
                                    <div class="row cart-total-products">
                                        <div class="col-7 align-self-end left">{{ translations['Total price tax included'] }}</div>
                                        <div class="col-5 right">{{ summary.formattedPrices.total_price_tax_included_only_products }}</div>
                                    </div>
                                    <div class="row align-self-center d-mobile-only left">
                                        <div class="col-12 col-lg-6">
                                            <voucher
                                                    :voucher="voucher"
                                                    :translations="translations"
                                                    @applyVoucher="$emit('applyVoucher')"
                                                    @removeVoucher="$emit('removeVoucher')"
                                            />
                                        </div>
                                    </div>
                                    <div class="row mt-2 mt-lg-4 cart-delivery">
                                        <div class="col-12 col-lg-6 left">{{ translations['Delivery fee'] }}</div>
                                        <div class="col-12 col-lg-6 right" v-if="currentCarrier">{{ currentCarrier.formattedPrices.price }}</div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-lg-6 left">{{ translations['Payment fee'] }}</div>
                                        <div class="col-12 col-lg-6 right" v-if="currentPayment">{{ currentPayment.formattedPrices.price }}</div>
                                    </div>
                                    <div class="row mt-2 mt-lg-4 pt-2 pt-lg-4 summary">
                                        <div class="col-12 align-self-center d-desktop-only">
                                            <voucher
                                                    :voucher="voucher"
                                                    :translations="translations"
                                                    @applyVoucher="$emit('applyVoucher')"
                                                    @removeVoucher="$emit('removeVoucher')"
                                            />
                                        </div>
                                      <div class="cc-theme__rounding" v-if="rounding">
                                        <div class="col-9">{{ translations['Rounding according to law'] }}</div>
                                        <div class="col-3 text-right">{{ formattedRounding }}</div>
                                      </div>
                                        <div class="col-12 total">
                                            {{ translations['Total'] }} <span class="float-right">{{ summary.formattedPrices.total_price_tax_included }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <free-gift />
                    </div>
                </div>
                <div class="row mt-4 mt-xl-5" v-if="$root.mobile">
                    <div class="col">
                        <random-products />
                    </div>
                </div>
                <div class="row mt-4 mt-xl-5" v-if="$root.mobile === false">
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <accessories />
                            </div>
                        </div>
                        <div class="row mt-4 mt-xl-5">
                            <div class="col">
                                <random-products />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col mt-4 mt-xl-0">
                <div class="row">
                    <div class="col">
                        <h3>{{ translations['Delivery address'] }}</h3>
                        <span class="header-info-yellow">{{ translations['all fields are required'] }}</span>
                    </div>
                </div>
                <form>
                    <div class="form-row delivery-address">
                        <div class="col">
                            <div class="form-group">
                                <label for="deliveryAddress.firstname">{{ translations['First name'] }}</label>
                                <input id="deliveryAddress.firstname" type="text" :value="user.deliveryAddress.firstname" @change="updateFirstname" class="form-control" :class="{ 'is-invalid': user.errors.deliveryAddress.firstname }">
                                <div class="invalid-feedback" v-if="user.errors.deliveryAddress.firstname">{{ user.errors.deliveryAddress.firstname }}</div>
                            </div>
                            <div class="form-group">
                                <label for="deliveryAddress.lastname">{{ translations['Last name'] }}</label>
                                <input id="deliveryAddress.lastname" type="text" :value="user.deliveryAddress.lastname" @change="updateLastname" class="form-control" :class="{ 'is-invalid': user.errors.deliveryAddress.lastname }">
                                <div class="invalid-feedback" v-if="user.errors.deliveryAddress.lastname">{{ user.errors.deliveryAddress.firstname }}</div>
                            </div>
                            <div class="form-group">
                                <label for="deliveryAddress.addressLine1">{{ translations['Address Line 1'] }}</label>
                                <input id="deliveryAddress.addressLine1" type="text" :value="user.deliveryAddress.addressLine1" @change="updateAddressLine1" class="form-control" :class="{ 'is-invalid': user.errors.deliveryAddress.addressLine1 }">
                                <div class="invalid-feedback" v-if="user.errors.deliveryAddress.addressLine1">{{ user.errors.deliveryAddress.addressLine1 }}</div>
                            </div>
                            <div class="form-group">
                                <label for="deliveryAddress.city">{{ translations['City'] }}</label>
                                <input id="deliveryAddress.city" type="text" :value="user.deliveryAddress.city" @change="updateCity" class="form-control" :class="{ 'is-invalid': user.errors.deliveryAddress.city }">
                                <div class="invalid-feedback" v-if="user.errors.deliveryAddress.city">{{ user.errors.deliveryAddress.city }}</div>
                            </div>
                            <div class="form-group">
                                <label for="deliveryAddress.country">{{ translations['Country'] }}</label>
                                <select id="deliveryAddress.country" :value="user.deliveryAddress.country" @change="updateCountry" class="form-control" :class="{ 'is-invalid': user.errors.deliveryAddress.country }">
                                    <option v-for="country in config.countries" :key="country.id" :value="country.id">{{ country.name }}</option>
                                </select>
                                <div class="invalid-feedback" v-if="user.errors.deliveryAddress.country">{{ user.errors.deliveryAddress.country }}</div>
                            </div>
                            <div class="form-group">
                                <label for="deliveryAddress.postalCode">{{ translations['Postal code'] }}</label>
                                <input id="deliveryAddress.postalCode" type="text" :value="user.deliveryAddress.postalCode" @change="updatePostalCode" class="form-control zipCode" :class="{ 'is-invalid': user.errors.deliveryAddress.postalCode }">
                                <div class="invalid-feedback" v-if="user.errors.deliveryAddress.postalCode">{{ user.errors.deliveryAddress.postalCode }}</div>
                            </div>
                            <div class="form-group">
                                <label for="deliveryAddress.email">{{ translations['E-mail'] }}</label>
                                <input id="deliveryAddress.email" type="text" :value="user.deliveryAddress.email" @change="updateEmail" class="form-control" :class="{ 'is-invalid': user.errors.deliveryAddress.email }" :disabled="isLoggedIn">
                                <div class="invalid-feedback" v-if="user.errors.deliveryAddress.email">{{ user.errors.deliveryAddress.email }}</div>
                            </div>
                            <div class="form-group">
                                <label for="deliveryAddress.phone">{{ translations['Phone'] }}</label>
                                <input id="deliveryAddress.phone" type="text" :value="user.deliveryAddress.phone" @change="updatePhone" class="form-control" :class="{ 'is-invalid': user.errors.deliveryAddress.phone }">
                                <div class="invalid-feedback" v-if="user.errors.deliveryAddress.phone">{{ user.errors.deliveryAddress.phone }}</div>
                            </div>
                        </div>
                    </div>
                </form>
                <div class="row">
                    <div class="col">
                        <input id="differentInvoiceAddress" type="checkbox" class="form-check-input" :checked="user.differentInvoiceAddress" @change="changeDifferentInvoiceAddress">
                        <label for="differentInvoiceAddress" class="form-check-label">{{ translations['Different invoice address'] }}</label>
                        <form v-if="user.differentInvoiceAddress" class="mt-4 mt-xl-5">
                            <h3>{{ translations['Invoice address'] }}</h3>
                            <div class="form-row delivery-address">
                                <div class="col">
                                    <div class="form-group">
                                        <label for="invoiceAddress.firstname">{{ translations['First name'] }}</label>
                                        <input id="invoiceAddress.firstname" type="text" :value="user.invoiceAddress.firstname" @change="updateInvoiceFirstname" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.firstname }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.firstname">{{ user.errors.invoiceAddress.firstname }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label for="invoiceAddress.lastname">{{ translations['Last name'] }}</label>
                                        <input id="invoiceAddress.lastname" type="text" :value="user.invoiceAddress.lastname" @change="updateInvoiceLastname" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.lastname }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.lastname">{{ user.errors.invoiceAddress.firstname }}</div>
                                    </div>
                                    <div class="form-group" v-if="optionalAddressFields.invoiceAddress.company === false">
                                        <label for="invoiceAddress.company">{{ translations['Company'] }}</label>
                                        <input id="invoiceAddress.company" type="text" :value="user.invoiceAddress.company" @change="updateInvoiceCompany" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.company }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.company">{{ user.errors.invoiceAddress.company }}</div>
                                    </div>
                                    <div class="form-group" v-if="optionalAddressFields.invoiceAddress.identificationNumber === false">
                                        <label for="invoiceAddress.identificationNumber">{{ translations['Identification number'] }}</label>
                                        <input id="invoiceAddress.identificationNumber" type="text" :value="user.invoiceAddress.identificationNumber" @change="updateInvoiceIdentificationNumber" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.identificationNumber }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.identificationNumber">{{ user.errors.invoiceAddress.identificationNumber }}</div>
                                    </div>
                                    <div class="form-group" v-if="optionalAddressFields.invoiceAddress.taxIdentificationNumber === false">
                                        <label for="invoiceAddress.taxIdentificationNumber">{{ translations['Tax identification number'] }}</label>
                                        <input id="invoiceAddress.taxIdentificationNumber" type="text" :value="user.invoiceAddress.taxIdentificationNumber" @change="updateInvoiceTaxIdentificationNumber" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.taxIdentificationNumber }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.taxIdentificationNumber">{{ user.errors.invoiceAddress.taxIdentificationNumber }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label for="invoiceAddress.addressLine1">{{ translations['Address Line 1'] }}</label>
                                        <input id="invoiceAddress.addressLine1" type="text" :value="user.invoiceAddress.addressLine1" @change="updateInvoiceAddressLine1" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.addressLine1 }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.addressLine1">{{ user.errors.invoiceAddress.addressLine1 }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label for="invoiceAddress.city">{{ translations['City'] }}</label>
                                        <input id="invoiceAddress.city" type="text" :value="user.invoiceAddress.city" @change="updateInvoiceCity" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.city }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.city">{{ user.errors.invoiceAddress.city }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label for="invoiceAddress.country">{{ translations['Country'] }}</label>
                                        <select id="invoiceAddress.country" :value="user.invoiceAddress.country" @change="updateInvoiceCountry" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.country }">
                                            <option v-for="country in countries" :key="country.id" :value="country.id">{{ country.name }}</option>
                                        </select>
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.country">{{ user.errors.invoiceAddress.country }}</div>
                                    </div>
                                    <div class="form-group">
                                        <label for="invoiceAddress.postalCode">{{ translations['Postal code'] }}</label>
                                        <input id="invoiceAddress.postalCode" type="text" :value="user.invoiceAddress.postalCode" @change="updateInvoicePostalCode" class="form-control zipCode" :class="{ 'is-invalid': user.errors.invoiceAddress.postalCode }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.postalCode">{{ user.errors.invoiceAddress.postalCode }}</div>
                                    </div>
                                    <div class="form-group" v-if="optionalAddressFields.invoiceAddress.email === false">
                                        <label for="invoiceAddress.email">{{ translations['E-mail'] }}</label>
                                        <input id="invoiceAddress.email" type="text" :value="user.invoiceAddress.email" @change="updateInvoiceEmail" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.email }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.email">{{ user.errors.invoiceAddress.email }}</div>
                                    </div>
                                    <div class="form-group" v-if="optionalAddressFields.invoiceAddress.phone === false">
                                        <label for="invoiceAddress.phone">{{ translations['Phone'] }}</label>
                                        <input id="invoiceAddress.phone" type="text" :value="user.invoiceAddress.phone" @change="updateInvoicePhone" class="form-control" :class="{ 'is-invalid': user.errors.invoiceAddress.phone }">
                                        <div class="invalid-feedback" v-if="user.errors.invoiceAddress.phone">{{ user.errors.invoiceAddress.phone }}</div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row mt-4 mt-xl-5">
                            <div class="col">
                                <carriers />
                            </div>
                        </div>
                        <div class="row mt-4 mt-xl-5">
                            <div class="col">
                                <payments />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p>{{ translations['By continuing you agree with'] }} <a :href="config.consents.terms_of_use.link" class="text-decoration-underline" target="_blank">{{ translations['terms of use'] }}</a> {{ translations['and'] }} <a :href="config.consents.privacy_policy.link" class="text-decoration-underline" target="_blank">{{ translations['privacy policy'] }}.</a></p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <input class="form-check-input" type="checkbox" id="newsletter" v-model="user.newsletter">
                                <label class="form-check-label" for="newsletter">{{ translations['I want to know about latest news and discounts'] }}</label>
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col">
                                <button @click="$emit('finishOrder')" class="order-button">{{ translations['Order'] }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="paymentshooks" style="visibility: hidden; position: absolute" v-html="paymentHooks"></div>
    </div>
</template>
<script>
    import { mapState } from "vuex";
    import Voucher from "./Voucher";
    import FreeGift from "./FreeGift";
    import Accessories from "./Accessories";
    import RandomProducts from "./RandomProducts";
    import Carriers from "./Carriers";
    import Payments from "./Payments";
    import ProductLine from "./ProductLine";
    export default {
        components: {ProductLine, Payments, Carriers, RandomProducts, Accessories, FreeGift, Voucher},
        props: [
            'translations',
            'products',
            'formatPrice',
            'user',
            'optionalAddressFields',
            'voucher',
            'countries',
            'isLoggedIn',
        ],
        computed: mapState({
            currentCarrier: state => state.currentCarrier,
            currentPayment: state => state.currentPayment,
            paymentHooks: state => state.paymentHooks,
            config: state => state.config,
            summary: state => state.summary,
            rounding: state => state.rounding,
            formattedRounding: state => state.formattedRounding,
        }),
        methods: {
            updateFirstname: function (event) {
                this.$store.dispatch('UPDATE_FIRSTNAME', event.target.value);
            },
            updateLastname: function (event) {
                this.$store.dispatch('UPDATE_LASTNAME', event.target.value);
            },
            updateEmail: function (event) {
                this.$store.dispatch('UPDATE_EMAIL', event.target.value);
            },
            updateAddressLine1: function (event) {
                this.$store.dispatch('UPDATE_ADDRESS_LINE_1', event.target.value);
            },
            updateCity: function (event) {
                this.$store.dispatch('UPDATE_CITY', event.target.value);
            },
            updateCountry: function (event) {
                this.$emit('showLoading');
                this.$store.dispatch('UPDATE_COUNTRY_NO_SYNC', event.target.value);
            },
            updatePostalCode: function (event) {
                this.$store.dispatch('UPDATE_POSTAL_CODE', event.target.value);
            },
            updatePhone: function (event) {
                this.$store.dispatch('UPDATE_PHONE', event.target.value);
            },
            updateInvoiceFirstname: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_FIRSTNAME', event.target.value);
            },
            updateInvoiceLastname: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_LASTNAME', event.target.value);
            },
            updateInvoiceCompany: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_COMPANY', event.target.value);
            },
            updateInvoiceIdentificationNumber: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_IDENTIFICATION_NUMBER', event.target.value);
            },
            updateInvoiceTaxIdentificationNumber: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_TAX_IDENTIFICATION_NUMBER', event.target.value);
            },
            updateInvoiceEmail: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_EMAIL', event.target.value);
            },
            updateInvoiceAddressLine1: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_ADDRESS_LINE_1', event.target.value);
            },
            updateInvoiceCity: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_CITY', event.target.value);
            },
            updateInvoiceCountry: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_COUNTRY', event.target.value);
            },
            updateInvoicePostalCode: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_POSTAL_CODE', event.target.value);
            },
            updateInvoicePhone: function (event) {
                this.$store.dispatch('UPDATE_INVOICE_PHONE', event.target.value);
            },
            changeDifferentInvoiceAddress: function (event) {
                this.user.differentInvoiceAddress = event.target.checked;

                if (this.user.differentInvoiceAddress === false) {
                    this.user.invoiceAddress.firstname = '';
                    this.user.errors.invoiceAddress.firstname = '';
                    this.user.invoiceAddress.lastname = '';
                    this.user.errors.invoiceAddress.lastname = '';
                    this.user.invoiceAddress.email = '';
                    this.user.errors.invoiceAddress.email = '';
                    this.user.invoiceAddress.phone = '';
                    this.user.errors.invoiceAddress.phone = '';
                    this.user.invoiceAddress.addressLine1 = '';
                    this.user.errors.invoiceAddress.addressLine1 = '';
                    this.user.invoiceAddress.city = '';
                    this.user.errors.invoiceAddress.city = '';
                    this.user.invoiceAddress.country = '';
                    this.user.errors.invoiceAddress.country = '';
                    this.user.invoiceAddress.postalCode = '';
                    this.user.errors.invoiceAddress.postalCode = '';
                    this.user.invoiceAddress.company = '';
                    this.user.errors.invoiceAddress.company = '';
                    this.user.invoiceAddress.identificationNumber = '';
                    this.user.errors.invoiceAddress.identificationNumber = '';
                    this.user.invoiceAddress.taxIdentificationNumber = '';
                    this.user.errors.invoiceAddress.taxIdentificationNumber = '';
                }
            }
        }
    }
</script>
<style scoped lang="scss">
    h3 {
        font-size: 24px;
        font-weight: 700;
        text-transform: uppercase;
        @media (max-width: 1349px) {
            text-align: center;
        }
    }

    .text-decoration-underline {
        text-decoration: underline !important;
    }

    #products-box {
        background-color: #f2f2f2;
        padding: 10px;

        .summary-box {
            padding-left: 32px;
            padding-right: 32px;
            font-weight: 700;
            text-transform: uppercase;

            .left {
                font-size: 21px;
            }

            .right {
                font-size: 24px;
                text-align: right;
            }

            .summary {
                border-top: 3px solid;
                .total {
                    font-size: 36px;
                }
            }

            @media (max-width: 1349px) {
                margin-top: 25px;
            }
        }
    }

    .header-info-yellow {
        color: #f1b507;
        font-size: 14px;
        font-weight: 500;
        margin-top: -8px;
        display: block;
        height: 1.5rem;
    }

    .delivery-address {
        input {
            max-width: 100%;
            width: 300px;
            &.zipCode {
                width: 100px;
            }
        }

        select {
            width: 40%;
            background-image: url('/themes/realgeek/img/chevron-down.svg');
            background-position: calc(100% - 10px) 14px, calc(100% - 20px) 14px, 100% 0;
            background-size: 12px 12px, 12px 12px;
            background-repeat: no-repeat;
            -webkit-appearance: none;
            -moz-appearance: none;
            margin: 0;

            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                -moz-appearance: initial;
                -webkit-appearance: initial;
                appearance: initial;
                background: transparent;
                padding: 0.375rem 0.75rem;
            }

            @media (max-width: 1349px) {
                width: 300px;
                max-width: 100%;
            }
        }
    }

    .order-button {
        background-color: #6eb540;
        width: 300px;
        max-width: 100%;
        height: 65px;
        font-size: 25px;
        font-weight: 700;
        color: #ffffff;
        border: none;
        border-radius: 4px;
        text-transform: uppercase;

        &:hover {
            background-color: #2d7900;
        }
    }

    input[type="checkbox"] {
        margin-left: 0;
        margin-top: -0.2rem;
        position: static;
        margin-right: 0.3rem;
        width: 1rem;
        height: 1rem;
        vertical-align: middle;
    }
    @media (max-width: 1349px) {
        #products-box {
            padding: 0;
            .summary-box{
                margin-bottom: 25px;
                padding-left: 17px;
                padding-right: 17px;
                .left, .right {
                    font-size: 18px;
                }
                .summary{
                    .total{
                        font-size: 26px;
                    }
                }
            }
        }

        h2{
            margin-top: 18px;
        }

        .cart-products{
            background: #f2f2f2;
            h3{
                margin: 15px 0 -5px;
            }
        }
        .row, .form-group{
            font-size: 14px;
        }
    }
    .cc-theme__rounding {
      @media (max-width: 1349px) {
        padding-right: 15px;
        padding-left: 15px;
      }
    }
</style>
<style>
    #paymentshooks img {
        width: 1px;
        height: 1px;
    }
</style>